"use client";

import { useTranslations } from "next-intl";
import { Text } from "@leabankab/component-library";
import { Heading } from "@/components/ui";
import { ApprovedPageContext } from "../types";
import { CardUpsell } from "./card-upsell";

interface Props {
	context: ApprovedPageContext;
	/** Which product copy to render. */
	process: "loan" | "myMoney";
}

const SHOW_CREDITCARD_UPSELL = false;

/**
 * Post-signing confirmation message. Consolidates the previously duplicated
 * loan/my-money approved components; only the translation copy differs.
 */
export const ApprovedMessage = ({ context, process }: Props) => {
	const t = useTranslations("pages.ApprovedPage");
	const { isCoapplicant, hasCoapplicant } = context;

	const copy =
		process === "loan"
			? {
					coApplicant: t("loan.text.coApplicant"),
					soleApplicant: t("loan.text.soleApplicant.text1"),
					mainApplicant: t("loan.text.mainApplicant.text1"),
				}
			: {
					coApplicant: t("myMoney.text.coApplicant"),
					soleApplicant: t("myMoney.text.soleApplicant.text1"),
					mainApplicant: t("myMoney.text.mainApplicant.text1"),
				};

	const body = isCoapplicant
		? copy.coApplicant
		: !hasCoapplicant
			? copy.soleApplicant
			: copy.mainApplicant;

	return (
		<>
			<Heading level={1} textStyle="heading-lg">
				{t("common.text.header")}
			</Heading>
			<Text textStyle="body-lg">{body}</Text>
			{process === "loan" && (
				<CardUpsell show={SHOW_CREDITCARD_UPSELL && isCoapplicant} />
			)}
		</>
	);
};
